module.exports = __webpack_public_path__ + "img/info.56156008.png";